<div class="row">
    <div>
      <nb-select size="tiny" placeholder="Visita" [(ngModel)]="buqueSelected" (ngModelChange)="changeBuque(buqueSelected)">
          <nb-option *ngFor="let buq of buques" [value]="buq.Codigo">{{buq.Name}}</nb-option>
      </nb-select>
    </div>
    <div>
      <!-- [(selected)]="operadorOptions" -->
      <!-- <nb-select size="tiny" placeholder="Operador" [disabled]="deshabilitarOperador" [(ngModel)]="operadorSelected" (ngModelChange)="changeOperador(operadorSelected)">
          <nb-option *ngFor="let oper of operadores" [value]="oper">{{oper.name}}</nb-option> -->
      <nb-select size="tiny" placeholder="Operador" [disabled]="deshabilitarOperador" [(ngModel)]="operadorSelected" (ngModelChange)="changeOperador()">
        <nb-option *ngFor="let oper of operadores" [value]="oper">{{oper.name}}</nb-option>
      </nb-select>
    </div>
    <div>
      <nb-select [disabled]="deshabilitarProceso" size="tiny" placeholder="Proceso" [(ngModel)]="procesoSelected" (ngModelChange)="changeProceso(procesoSelected)">
          <nb-option *ngFor="let proc of procesos" 
          [value]="proc.Codigo">{{proc.Name}}</nb-option>
      </nb-select>
    </div>
    <div style="margin-left: 8px;">
      <button [disabled]="deshabilitarBuscar" nbButton size="tiny" class=" buttontz" (click)="buscarVisita()">Buscar</button>
    </div> 
</div>
<div>
  <span *ngIf="procesoSelected == 1" style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder;"> ETA: </span><span *ngIf="procesoSelected == 1 ">{{infoETA}}</span>
  <span *ngIf="procesoSelected == 1" style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder;"> ATA: </span><span *ngIf="procesoSelected == 1 ">{{infoATA}}</span>
  <span *ngIf="procesoSelected == 2" style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder;"> ETD: </span><span *ngIf="procesoSelected == 2 ">{{infoETD}}</span>
  <span *ngIf="procesoSelected == 2" style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder;"> ATD: </span><span *ngIf="procesoSelected == 2 ">{{infoATD}}</span>
  <span *ngIf="showGridModif" style="margin-left: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder;">Visita: </span><span *ngIf="showGridModif">{{estadoVisita}}</span>
  <span *ngIf="showGridModif" style="margin-left: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder;">Código de Verificación: </span><span *ngIf="showGridModif">{{codVerificacion}}</span>

  <span *ngIf="showGridModif" style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder; float: right;">
    VINs: {{cantidadVins}}
    Filtrados: {{filtrado}}
  </span>
</div>

<app-spinner *ngIf="showSpinner"></app-spinner>       
<div *ngIf="showGridModif">
    <!-- <angular-slickgrid gridId="gridConsulVisita"
        [columnDefinitions]="columnDefinitionsVinsConsulta"
        [gridOptions]="gridOptionsVinsConsulta" 
        [dataset]="datasetConsultas" 
        gridHeight="380"
        gridWidth="100%"
        (onAngularGridCreated)="angularGridReady($event)"
        (sgOnRowCountChanged)="refreshMetrics($event.detail.args)">
        </angular-slickgrid> -->

        <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetConsultas"
            [columnDefs]="columnDefinitionsVinsConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>

</div>    